// Toggle "chevron"
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('button[data-bs-target^="#collapse-"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        btn.innerHTML = window.WP_SVG_ICONS['chevron-up'];
      } else {
        btn.innerHTML = window.WP_SVG_ICONS['chevron-down'];
      }
    });
  });
});

// Toggle "folder"
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('button[data-bs-target^="#collapse-"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      setTimeout(function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        // var pageItem = btn.closest('.page-item-has-children');
        // var pageItem = btn.closest('.page-item-has-posts');
        var pageItem = btn.closest('.page-item-has-children, .page-item-has-posts');
        if (pageItem) {
          var svgFolder = pageItem.querySelector('.bi-enyse-folder, .bi-enyse-folder2-open');
          if (svgFolder) {
            if (expanded) {
              svgFolder.outerHTML = window.WP_SVG_ICONS['enyse-folder_open'];
            } else {
              svgFolder.outerHTML = window.WP_SVG_ICONS['enyse-folder'];
            }
          }
        }
      }, 50);
    });
  });
});

// Resize height ".menu-homepage > div > div.card"
(function() {
  let resizeTimeout;
  function ajustarAltosCards() {
    const cards = document.querySelectorAll('.menu-homepage > div > div.card');
    if (!cards.length) return;
    cards.forEach(card => {
      card.style.height = 'auto';
    });
    let maxHeight = 0;
    cards.forEach(card => {
      const h = card.offsetHeight;
      console.log(h);
      if (h > maxHeight) maxHeight = h;
    });
    cards.forEach(card => {
      card.style.height = maxHeight + 'px';
    });
  }
  window.addEventListener('DOMContentLoaded', function() {
    setTimeout(ajustarAltosCards, 500);
  });
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(ajustarAltosCards, 500);
  });
})();


// // bloqueo del menu mobile
// document.addEventListener('DOMContentLoaded', function() {
//   var nav = document.getElementById('mainMenu');
//   var toggler = document.querySelector('.navbar-toggler');
//   var html = document.documentElement;
//   var body = document.body;
  
//   nav.addEventListener('show.bs.collapse', function () {
//     body.style.overflow = 'hidden';
//     html.style.overflow = 'hidden';
//   });
//   nav.addEventListener('hidden.bs.collapse', function () {
//     body.style.overflow = '';
//     html.style.overflow = '';
//   });
// });
